import API from '../../utils/api';
import * as types from './types';
import { defaultLocale } from '../../utils/translation';
import { ENDPOINT_URL } from '../../constants/defaultValues';

// GET TICKET BY TICKET CODE ACTION CREATOR
export const getTicket = ticketCode => async dispatch => {
    try {
        dispatch({
            type: types.GET_TICKET_REQUEST,
        });
        const lang = localStorage.getItem('lang') || defaultLocale;

        const res = await API.get(`${ENDPOINT_URL}/tickets/${ticketCode}`, {
            headers: { 'x-lang': lang },
        });

        const { info, item } = res.data;

        if (info.success) {
            dispatch({
                type: types.GET_TICKET_SUCCESS,
                payload: item,
            });

            return item;
        }
    } catch (err) {
        const { info } = err.response.data;
        dispatch({
            type: types.GET_TICKET_FAILED,
            payload: info.errors,
            error: true,
        });
    }
};

export const clearTicket = () => dispatch => dispatch({ type: types.CLEAR_TICKET });

export const setTicketScanned = value => ({
    type: types.TICKET_SCANNED,
    payload: value,
});
